import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SidebarBaseComponent } from './sidebar-base.component';
import { AuthenticatedUser, Club } from '~core/models';
import { CustomerService, NavigationService, StorageService } from '~core/services';


/**
 * Content for the customer search sidebar.
 */
@UntilDestroy()
@Component({
  selector: 'app-customer-search-sidebar',
  template: `
  <nav class="esf-app-menu esf-accordion">
    <div class="esf-app-menu__unit">
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.home'
          [routerLink]="['/club/' + this.selectedClub?.id]">Home</a>
      </div>
      <div class="esf-app-menu__item esf-accordion__trigger" menuItem
          i18n='Sidebar menu item@@sidebarComponent.menu.search'>Search</div>
      <div class="esf-app-menu__sub-items esf-accordion__target">
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'customerSearchBasic'}">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.searchBasic' [routerLink]="this.basicSearchLink">Basic search</a>
        </div>
        <div class="esf-app-menu__sub-item" [ngClass]="{'-is-active': this.currentPage === 'customerSearchAdvanced'}">
          <a i18n='Sidebar menu item@@sidebarComponent.menu.searchAdvanced' [routerLink]="this.advancedSearchLink">Advanced search</a>
        </div>
      </div>
      <div class="esf-app-menu__item">
        <a i18n='Sidebar menu item@@sidebarComponent.menu.lastSearch' (click)="openLastSearch()"
          style="cursor: pointer;">Last search</a>
      </div>
    </div>
  </nav>
  `
})
export class CustomerSearchSidebarComponent extends SidebarBaseComponent implements OnDestroy {
  public authenticatedUser: AuthenticatedUser;

  public searchHistory: any;
  public selectedClub: Club;

  constructor(storage: StorageService, router: Router, navigationService: NavigationService,
              customerService: CustomerService, route: ActivatedRoute) {
    super(storage, route, navigationService, customerService, router);
  }

  public ngOnDestroy(): void { }
}
